import React from 'react';
import { useTranslation } from 'react-i18next';
import { presetSources, uiLang, useKinds } from '../kinds';
import { attributionOf, useSources } from '../sources';

/**
 * The footer's mention of the sources the member's types use besides TMDB
 * (whose own line stays on every page): Open Library's courtesy, the BnF's
 * Licence ouverte ("Source : BnF"), Google Books' (phase 4 §10). Mounted only
 * for a member with such a type, so nobody else asks for GET /sources.
 */
function SourceCredits({ presets }) {
  const { t, i18n } = useTranslation();
  const lang = uiLang(i18n);
  const kinds = useKinds();
  const sources = useSources();
  const ids = [...new Set(presets.flatMap(preset => presetSources(preset, kinds)))].filter(id => id !== 'tmdb');
  const credits = ids.map(id => attributionOf(id, sources, lang)).filter(Boolean);
  if (credits.length === 0) return null;
  return (
    <span className="app-footer__sources">
      {t('footer.sources')}{' '}
      {credits.map((credit, index) => (
        <React.Fragment key={credit.url}>
          {index > 0 && ' · '}
          <a href={credit.url} target="_blank" rel="noopener noreferrer">{credit.text}</a>
        </React.Fragment>
      ))}
    </span>
  );
}

export default SourceCredits;
